import { getDefaultRoute } from './getDefaultRoute';

const ADMIN_PREFIX = /^\/admin(\/|$)/;
const FACULTY_PREFIX = /^\/faculty(\/|$)/;
const STUDENT_PREFIX = /^\/student(\/|$)/;

/**
 * Whether `role` may open `pathname` (role-scoped area only).
 * Legacy paths outside /admin|/faculty|/student are treated as reachable for any authenticated user
 * (they are handled by redirects in the router).
 *
 * RBAC Migration (Phase F): Removed legacy cbcfaculty role check.
 * Faculty paths require faculty base role (which provides default_faculty responsibility).
 * Additional faculty specializations (coding, placement, etc.) are gated at the route level via capabilities.
 *
 * @param {string | undefined} role
 * @param {string | undefined} pathname
 * @returns {boolean}
 */
export function canRoleAccessPath(role, pathname) {
  if (!role || !pathname) return false;
  const p = pathname;
  if (p === '/login' || p === '/') return false;
  if (ADMIN_PREFIX.test(p)) return role === 'admin';
  if (FACULTY_PREFIX.test(p)) return role === 'faculty';
  if (STUDENT_PREFIX.test(p)) return role === 'student';
  return true;
}

/**
 * After login, return a safe in-app path: intended `from` if allowed for the role, else role home.
 *
 * @param {string | undefined} role
 * @param {string | undefined} fromPathname
 * @param {{ role?: string, subtype?: string, facultyType?: string } | null | undefined} [user]
 * @returns {string}
 */
export function getPostLoginRedirect(role, fromPathname, user) {
  if (fromPathname && canRoleAccessPath(role, fromPathname)) {
    return fromPathname;
  }
  return getDefaultRoute(role, user);
}
